import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";
import { isAxiosError } from "axios";
import { useAdminStore } from "../store/adminStore";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//^ TRAE TODA LAS ACTAS
export const getActas = async (params) => {
  let newParams = null;
  if (params) {
    newParams = new URLSearchParams(params).toString();
  }
  handlerLoading({ loading: true, loadName: `get_actas` });
  try {
    const response = await axios().get(`actas?${newParams}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "get_actas" });
  }
};

//^ TRAE INFORMACION DE UN ACTA
export const getActa = async (id) => {
  handlerLoading({ loading: true, loadName: "get_acta" });
  try {
    const response = await axios().get(`acta/${id}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "get_acta" });
  }
};

//^ TRAE TODO LOS INSPECTORES
export const getInspectores = async () => {
  handlerLoading({ loading: true, loadName: "inspectores" });
  try {
    const response = await axios().get("get_inspectores");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    } else {
      toast.error("Hubo un error en la consulta");
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "inspectores" });
  }
};

//^ ASIGNAR SOLICITUDES A UN INSPECTOR
export const asignarSolicitudes = async (payload) => {
  handlerLoading({ loading: true, loadName: "asignar_solicitudes" });
  try {
    const response = await axios().post("asignar_solicitudes", payload);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      toast.success("Se asignaron solicitudes correctamente", toastOptions);
      return data;
    } else {
      toast.error("Hubo un error en la consulta");
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "asignar_solicitudes" });
  }
};

//^PUEDE SUBIR UNA CONSTATACION
export const enviarConstatacion = async (payload) => {
  const formData = new FormData();

  if (payload.acta_id) {
    formData.append("acta_id", payload.acta_id);
  }
  if (payload.constatacion_file.length > 0) {
    formData.append("constatacion_file", payload.constatacion_file[0]);
  }
  if (payload.numero_acta) {
    formData.append("numero_acta", payload.numero_acta);
  }
  if (payload.descripcion_tarea) {
    formData.append("descripcion_tarea", payload.descripcion_tarea);
  }
  if (payload.constatacion_dano) {
    formData.append("constatacion_dano", payload.constatacion_dano);
  }
  if (payload.observacion) {
    formData.append("observacion", payload.observacion);
  }

  handlerLoading({ loading: true, loadName: "enviar_constatacion" });
  try {
    const response = await axios().post(`constatacion`, formData);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      toast.success("Constatación enviada correctamente", toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "enviar_constatacion" });
  }
};

//^CAMBIA ESTADO DE UN ACTA
export const cambiarEstadoActa = async (payload) => {
  handlerLoading({ loading: true, loadName: "cambiar_estado" });
  try {
    const response = await axios().post(`acta/cambiar_estado/${payload}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      if (data.estado_id == 2) {
        toast.success("El acta fue aceptada", toastOptions);
      }
      if (data.estado_id == 8) {
        toast.success("El acta fue finalizada", toastOptions);
      }
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "cambiar_estado" });
  }
};

export const primeraEtapa = async (payload) => {
  handlerLoading({ loading: true, loadName: "load_form" });
  try {
    const response = await axios().post("/acta/primera_etapa", payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_form" });
  }
};

export const segundaEtapa = async (payload, id) => {
  handlerLoading({ loading: true, loadName: "load_form" });
  try {
    const response = await axios().post(`/acta/segunda_etapa/${id}`, payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_form" });
  }
};

//TODO trae toda als actas segun su estado y los filtros
export const terceraEtapa = async (payload, id) => {
  handlerLoading({ loading: true, loadName: "tercera_etapa" });
  try {
    // const response = await axios().post(`/acta/tercera_etapa/${id}`, payload);
    const response = await axios().post(
      `/acta/tercera_etapa/${id}`,
      { files: payload },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "tercera_etapa" });
  }
};
